import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './FeedbackButton.css';

function FeedbackButton() {
    const [isOpen, setIsOpen] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [feedbackType, setFeedbackType] = useState('suggestion');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const { currentUser } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!feedback.trim()) return;

        setIsSubmitting(true);

        try {
            // For now, log to console - in production, send to a feedback endpoint
            console.log('Beta Feedback:', {
                type: feedbackType,
                feedback: feedback,
                user: currentUser?.email || 'anonymous',
                timestamp: new Date().toISOString(),
                page: window.location.pathname
            });

            // Show success state
            setSubmitted(true);
            setTimeout(() => {
                setIsOpen(false);
                setSubmitted(false);
                setFeedback('');
                setFeedbackType('suggestion');
            }, 2000);
        } catch (error) {
            console.error('Failed to submit feedback:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!currentUser) return null;

    return (
        <>
            {/* Floating Feedback Button */}
            <button
                className="feedback-toggle"
                onClick={() => setIsOpen(!isOpen)}
                title="Send Beta Feedback"
            >
                {isOpen ? '✕' : '💬'}
            </button>

            {/* Feedback Panel */}
            {isOpen && (
                <div className="feedback-panel">
                    <div className="feedback-header">
                        <span className="beta-badge">BETA</span>
                        <h3>Share Your Feedback</h3>
                        <p>Help us improve LearnViva!</p>
                    </div>

                    {submitted ? (
                        <div className="feedback-success">
                            <span className="success-icon">✅</span>
                            <p>Thank you for your feedback!</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="feedback-form">
                            <div className="feedback-types">
                                <button
                                    type="button"
                                    className={`feedback-type-btn ${feedbackType === 'bug' ? 'active' : ''}`}
                                    onClick={() => setFeedbackType('bug')}
                                >
                                    🐛 Bug
                                </button>
                                <button
                                    type="button"
                                    className={`feedback-type-btn ${feedbackType === 'suggestion' ? 'active' : ''}`}
                                    onClick={() => setFeedbackType('suggestion')}
                                >
                                    💡 Idea
                                </button>
                                <button
                                    type="button"
                                    className={`feedback-type-btn ${feedbackType === 'praise' ? 'active' : ''}`}
                                    onClick={() => setFeedbackType('praise')}
                                >
                                    ❤️ Love it
                                </button>
                            </div>

                            <textarea
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                placeholder={
                                    feedbackType === 'bug'
                                        ? "Describe the issue you encountered..."
                                        : feedbackType === 'suggestion'
                                        ? "What would make LearnViva better?"
                                        : "What do you love about LearnViva?"
                                }
                                rows={4}
                                required
                            />

                            <button
                                type="submit"
                                className="btn btn-primary feedback-submit"
                                disabled={isSubmitting || !feedback.trim()}
                            >
                                {isSubmitting ? 'Sending...' : 'Send Feedback'}
                            </button>
                        </form>
                    )}
                </div>
            )}
        </>
    );
}

export default FeedbackButton;
